import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // ✅ Ավելացրինք սրանք
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalculator, faChevronRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet';
// 1. Ներմուծում ենք բոլոր հաշվիչները
import DemolitionCalculator from './calculators/Demolition'; 
import BnHashvich from './calculators/MovingCalculator';
import TrashCalculator from './calculators/UnifiedLogisticsERP';
import FuraCalculator from './calculators/FuraCalculator';
import CleaningCalculator from './calculators/CleaningCalculator'; 
import MasterCalculator from './calculators/MasterCalculator'; 
import MachineryCalculator from './calculators/MachineryCalculator';

// 2. Ներմուծում ենք Պատվերի Մոդալը
import OrderModal from './OrderModal';

const CalculatorsHub = () => {
    const { t } = useTranslation();
    const { slug } = useParams(); // ✅ Վերցնում ենք /calculators/:slug-ից
    const navigate = useNavigate(); // ✅ Էջերի արագ փոխման համար
    
    const [selectedCalc, setSelectedCalc] = useState(null);
    const [width, setWidth] = useState(window.innerWidth);
    const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
    const [calcResultData, setCalcResultData] = useState(null);
    
    const goldColor = '#c5a059';

    // Քո բազայի տվյալներին համապատասխանեցված slug-երը
    const calculators = [
        { id: 1, slug: 'waste', name: t('calc_trash_removal'), component: TrashCalculator },
        { id: 2, slug: 'demolition', name: t('calc_demolition'), component: DemolitionCalculator },
        { id: 3, slug: 'moving', name: t('calc_moving'), component: BnHashvich },
        { id: 4, slug: 'cleaning', name: t('calc_cleaning'), component: CleaningCalculator },
        { id: 5, slug: 'master', name: t('calc_master'), component: MasterCalculator },
        { id: 6, slug: 'machinery', name: t('calc_machinery'), component: MachineryCalculator },
        { id: 7, slug: 'logistics', name: t('calc_fura'), component: FuraCalculator }
    ];

    // Resize handler
    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // ✅ Հիմնական տրամաբանությունը. սլագը փոխվեց՝ հաշվիչը փոխվում է
    useEffect(() => {
        if (slug) {
            const found = calculators.find(c => c.slug.toLowerCase() === slug.toLowerCase());
            if (found) {
                setSelectedCalc(found);
            } else {
                setSelectedCalc(null);
            }
        } else {
            setSelectedCalc(null);
        }
        window.scrollTo(0, 0);
    }, [slug, t]);

    const handleCalcResult = (price, details, fullData) => {
        if (fullData) {
            setCalcResultData(fullData);
        } else {
            setCalcResultData({ price, details });
        }
    };

    // Քարտին սեղմելիս փոխում ենք URL-ը
    const handleCardClick = (item) => {
        navigate(`/calculators/${item.slug}`);
    };

    // Հետ գնալու ֆունկցիան
    const handleBack = () => {
        navigate('/calculators');
        setCalcResultData(null);
    };

    const getGridColumns = () => {
        if (width > 1000) return 'repeat(3, 1fr)';
        if (width > 600) return 'repeat(2, 1fr)';
        return '1fr';
    };

    const s = {
        container: {
            padding: width > 768 ? '120px 20px' : '80px 15px',
            maxWidth: '1200px',
            margin: '0 auto',
            minHeight: '80vh',
            width: '100%',
            boxSizing: 'border-box'
        },
        mainTitle: { 
            textAlign: 'center', 
            fontWeight: '900', 
            marginBottom: '40px', 
            color: '#0f172a', 
            textTransform: 'uppercase',
            fontSize: width > 768 ? '32px' : '22px'
        },
        grid: { display: 'grid', gap: '20px', width: '100%' },
        card: {
            background: '#fff', 
            padding: '30px 20px', 
            borderRadius: '20px', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            cursor: 'pointer', 
            border: '1px solid #eee', 
            boxShadow: '0 5px 15px rgba(0,0,0,0.05)', 
            transition: '0.3s'
        },
        iconBox: { 
            width: '50px', height: '50px', borderRadius: '50%', display: 'flex', 
            alignItems: 'center', justifyContent: 'center', marginBottom: '15px' 
        },
        cardTitle: { fontSize: '15px', textAlign: 'center', fontWeight: '800', color: '#1e293b' },
        backBtn: { 
            background: 'none', border: 'none', color: goldColor, cursor: 'pointer', 
            fontWeight: '800', marginBottom: '20px', fontSize: '15px', display: 'flex', alignItems: 'center', gap: '8px'
        },
        calcCard: { 
            background: '#fff', 
            padding: width > 768 ? '40px' : '25px 15px', 
            borderRadius: '25px', 
            boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
            maxWidth: '850px',
            margin: '0 auto'
        },
        calcTitle: { textAlign: 'center', marginBottom: '25px', fontSize: '22px', fontWeight: '800' },
        orderBtn: { 
            width: '100%', color: '#fff', border: 'none', padding: '18px', borderRadius: '15px', 
            fontWeight: '800', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', marginTop: '20px'
        }
    };

    // --- ՀԱՇՎԻՉԻ ԷՋԸ ---
    if (selectedCalc) {
        const CalcComponent = selectedCalc.component;
        const displayPrice = calcResultData?.total_price || calcResultData?.price || 0;

        return (
            <div style={s.container}>
                <button onClick={handleBack} style={s.backBtn}>
                    <FontAwesomeIcon icon={faArrowLeft} /> {t('back_to_list')}
                </button>

                <div style={s.calcCard}>
                    <h2 style={s.calcTitle}>{selectedCalc.name}</h2>
                    <CalcComponent onResultChange={handleCalcResult} />

                    {displayPrice > 0 && (
                        <button onClick={() => setIsOrderModalOpen(true)} style={{...s.orderBtn, background: goldColor}}>
                            <span>{t('order_now')} - {displayPrice.toLocaleString()} ֏</span>
                            <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                    )}
                </div>

                <OrderModal 
                    isOpen={isOrderModalOpen} 
                    onClose={() => setIsOrderModalOpen(false)} 
                    serviceName={selectedCalc.name} 
                    calcData={calcResultData} 
                />
            </div>
        );
    }

    // --- ՑՈՒՑԱԿԻ ԷՋԸ ---
    return (
        <div style={s.container}>
            
            <h1 style={s.mainTitle}>{t('online_calculators')}</h1>
            <div style={{ ...s.grid, gridTemplateColumns: getGridColumns() }}>
                
                {calculators.map((item) => (
                    <div key={item.id} onClick={() => handleCardClick(item)} style={s.card}>
                        <div style={{ ...s.iconBox, background: `${goldColor}15` }}>
                            <FontAwesomeIcon icon={faCalculator} style={{ color: goldColor, fontSize: '20px' }} />
                        </div>
                        <h3 style={s.cardTitle}>{item.name}</h3>
                        <span style={{ color: goldColor, fontSize: '12px', marginTop: '10px' }}>
                            {t('calculate_btn')} <FontAwesomeIcon icon={faChevronRight} size="xs" />
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CalculatorsHub;